import { render, staticRenderFns } from "./AttachmentSelector.vue?vue&type=template&id=0f08f759&scoped=true&"
import script from "./AttachmentSelector.vue?vue&type=script&lang=js&"
export * from "./AttachmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentSelector.vue?vue&type=style&index=0&id=0f08f759&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f08f759",
  null
  
)

export default component.exports